exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    background: #343a40;\n}\n\n#sidebar {\n    min-width: 200px;\n    max-width: 200px;\n    height: 100vh;\n    color: #fff;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n    font-weight: 300;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n#sidebar.hidden {\n    margin-left: -200px;\n}\n\na[data-toggle=\"collapse\"] {\n    position: relative;\n}\n\n@media (max-width: 575px) {\n    #sidebar {\n        margin-left: -200px;\n    }\n\n    #sidebar.hidden {\n        margin-left: 0;\n    }\n}\n\na, a:hover, a:focus {\n    color: inherit;\n}\n\n#sidebar .sidebar-header {\n    padding: 20px;\n}\n\n#sidebar ul li a {\n    padding: 15px;\n    display: block;\n    width: 100%;\n}\n\nsidebar.hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\nhr {\n    border-top: 1px solid #fff;\n    margin-top: 0;\n}\n\n.vl {\n    border-left: 3px solid red;\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-side-nav/authorised-side-nav.component.css
// module id = ../../../../../src/app/layout/authorised/authorised-side-nav/authorised-side-nav.component.css
// module chunks = main